import React from "react";

function Academics() {
  return (
    <>
      <h2 className="mt-32 text-6xl text-center">
        These are words Academics SRCA.
      </h2>
    </>
  );
}

export default Academics;
